export default __webpack_public_path__ + "static/media/cp_geo_es-ct.208ddf7a.svg";